var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_19314",
    "data-name": "\\uADF8\\uB8F9 19314",
    transform: "translate(-171 -2978)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1134",
    "data-name": "\\uD0C0\\uC6D0 1134",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(171 2978)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plus",
    d: "M17.938,9.345H10.324V1.7a.5.5,0,0,0-.5-.5.479.479,0,0,0-.476.5V9.345H1.7a.5.5,0,0,0-.5.5.479.479,0,0,0,.5.476H9.345v7.613a.5.5,0,1,0,1.008,0V10.324h7.585a.5.5,0,0,0,.5-.5A.479.479,0,0,0,17.938,9.345Z",
    transform: "translate(177.296 2984.296)",
    fill: "#868e96",
    stroke: "#868e96",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.bf6ecd2af9d0337fea8bf11ff11b0540.svg";
export { ForwardRef as ReactComponent };